import React, { useEffect } from 'react'

interface TintimLinkProps extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  url: string
  onClick?: () => unknown
  children?: React.ReactNode
}

export const TintimLink = ({ url, onClick, children, ...props }: TintimLinkProps) => {
  const forceTintimLinksRefresh = () => {
    console.log('[TINTIM] Adding params to links')

    setTimeout(() => {
      const w = window as any
      if (w.tt) {
        w.tt.addParamsToLinks()
      }
    }, 500)
  }

  useEffect(() => {
    forceTintimLinksRefresh()
  }, [])

  return (
    <a href={url} onClick={onClick} onMouseEnter={forceTintimLinksRefresh} {...props}>
      {children}
    </a>
  )
}
